import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import TableReportHelper from "report/helper";
import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";

export default async function abaReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)
        const additionalColumn = indicador.type.field === "colheitas"
            ? {
                label: "Operador",
                field: "operador.operador",
                width: "*"
            }
            : undefined;

        content.push([
            await apontamentoHeaderLocalizacaoReport(visita, indicador, apontamento, params, undefined, undefined, additionalColumn),

            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                ["Qtd. Canas Avaliadas", "Tocos Abalados", "Abalos (%)"],
                // prettier-ignore
                (h) => [
                    h.textField("avaliados"),
                    h.textField("abalados"),
                    h.numberField("abalo"),
                ],
                [100, 80, 60]
            ),

            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
